module.exports = __webpack_public_path__ + "img/ew-icon_undecided.5b2d254f.svg";